import { render, staticRenderFns } from "./AddNoteBlockModal.vue?vue&type=template&id=236b4a9a&lang=pug&"
import script from "./AddNoteBlockModal.vue?vue&type=script&lang=js&"
export * from "./AddNoteBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNoteBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports